import { defineComponent, ExtractPropTypes, ref } from 'vue';
import { createNamespaceBem } from '@/utils';

interface IUserMsg {
  profileId?: string;
  photo?: string;
  fullNameMask?: string;
  age?: number;
  relation?: string;
  gender?: string;
}
export type HeaderTabBarProps = ExtractPropTypes<IUserMsg>;

const { bem } = createNamespaceBem('header-tab-bar');

export default defineComponent({
  props: {
    peopleLists: {
      type: Array<IUserMsg>,
      default: () => {
        return [];
      },
    },
    userIndex: {
      type: Number,
      default: 0,
    },
  },
  setup(props, ctx) {
    const { peopleLists } = toRefs(props);
    const currentUserIndex = ref(0);
    const handleTapBoxItem = (index, profileId) => {
      currentUserIndex.value = index;
      ctx.emit('tabChange', profileId);
    };
    watch(
      () => props.userIndex,
      (val) => {
        currentUserIndex.value = val;
      },
    );
    return () => {
      if (peopleLists.value?.length) {
        return (
          <div class={bem('box')}>
            {peopleLists.value.map((item, index) => (
              <div onClick={() => handleTapBoxItem(index, item.profileId)} class={bem('tab-bar')} key={item.profileId}>
                {index !== currentUserIndex.value && (
                  <div class={bem('info-box')}>
                    <span class={bem('name')}>{item.fullNameMask}</span>
                    <span class={bem('tag')}>{item.relation}</span>
                  </div>
                )}
                {index === currentUserIndex.value && <div class={bem('current-box')}>{item.fullNameMask}</div>}
              </div>
            ))}
          </div>
        );
      }
      return null;
    };
  },
});
